import _ from 'lodash';
import { ADMIN_CONTACT_PARTNER } from '../../constants/admin.contacts.constants';
import { partners } from '../bff.api';
import responseValidators from '../response.validators';

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const _createBody = (data) => {
  const result = {
    ..._.pick(data, ['name', 'postcode', 'city', 'streetName', 'houseNumber', 'province', 'phone', 'email', 'remarks']),
    type: ADMIN_CONTACT_PARTNER
  };

  return result;
};

const _updateBody = (data) => ({ ..._.omit(_createBody(data), 'type') });

const getPartnersOptions = async (options = {}) => {
  return partners
    .getAll()
    .then((resp) => {
      responseValidators.getAllPartners(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json?.map((p) => ({ value: p.id, label: p?.spoPartnerData?.name })) ?? []);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const add = async (data, options = {}) => {
  return partners
    .add(_createBody(data))
    .then((resp) => {
      responseValidators.addPartner(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const update = async (id, data, options = {}) => {
  const updateBody = _updateBody(data);
  return partners
    .update(id, updateBody)
    .then((resp) => {
      responseValidators.updatePartner(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const remove = async (id, options = {}) => {
  return partners
    .remove(id)
    .then((resp) => {
      responseValidators.removePartner(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const partnersService = { getPartnersOptions, add, update, remove };

export default partnersService;
